import React from 'react';

export default function Bio(){
	return (
		<div className='bio'>
			<p>Before I started coding, I spent many years at the U.S. Embassy in a small ex-Soviet country, telling America's story, promoting English language, and managing information and literacy programs. I also helped launch a food delivery start-up and volunteered in an organization that focused on preventing teens from joining street crime. I have a graduate degree in business and speak four languages. When I'm not coding, I hang out with family and friends, play sports or go out for long walks.</p>
		</div>
	);
}